import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { PurchaseCorrectionApi } from "../../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<PurchaseCorrectionApi>;
}

const PurchaseCorrectionCommentForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		register,
	} = form;

	return (
		<fieldset className="form-group">
			<div className="mb-3">
				<h5 className="mb-0">{t("modules.purchase.field.correction_comment.title")}</h5>
				<small className="text-muted">{t("modules.purchase.field.correction_comment.description")}</small>
			</div>
			<FormInput name="reason" errors={errors} register={register} label={t("common.word.comment.title")} />
		</fieldset>
	);
};

export default PurchaseCorrectionCommentForm;
